import React, { useState, useContext, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const InstallModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);

  const doClose = () => {
    window.location.reload();
    setOpen(false);
  }

  useEffect(() => {
    return actions.recv("open-install", function () {
      setOpen(true);
    });
  }, []);
  return open !== true ? null : (
    <Modal
      title="Loaded license successfully"
      onClose={doClose}
      closeLabel="RELOAD"
    />
  );
};
export default InstallModal;